// 选片链接表单（生成 / 管理编辑）共享的默认值与校验逻辑（独立于 delivery）。
// 复用通用的路径解析 parseDeliveryPath（与功能无关的 R2 路径校验）。
import dayjs from "dayjs";
import { parseDeliveryPath } from "./deliveryPath";
import {
    parseSelectionConsentClauseIds,
    stringifySelectionConsentClauseIds,
} from "./deliveryConsent";

export function defaultExpiry() {
    return dayjs().add(30, "day").hour(23).minute(59).second(59).millisecond(0);
}

export function emptySelectionFormValues() {
    return {
        albumPath: "",
        albumName: "",
        consentClauses: parseSelectionConsentClauseIds("general"),
        downloadAllType: "none",
        downloadAllToken: "",
        archiveMarkdown: "",
        expiry: defaultExpiry(),
    };
}

// 把已落库的选片链接转成表单初始值（用于编辑）。
export function selectionToFormValues(item) {
    return {
        albumPath: item.albumPath || "",
        albumName: item.albumName || "",
        consentClauses: parseSelectionConsentClauseIds(item.consent),
        downloadAllType: item.downloadAll?.type || "none",
        downloadAllToken: item.downloadAll?.value || "",
        archiveMarkdown: item.archiveMarkdown || "",
        expiry: item.expiry ? dayjs(item.expiry * 1000) : defaultExpiry(),
    };
}

// 校验并规整表单。返回 API 统一形状；失败抛出已翻译的错误。
export function validateSelectionForm(values, t, { allowExpiredExpiry = false } = {}) {
    const resource = parseDeliveryPath(values.albumPath);
    const albumName = (values.albumName || "").trim();
    if (!albumName) {
        throw new Error(t("selection.admin.albumNameRequired"));
    }
    if (!values.expiry) {
        throw new Error(t("selection.admin.expiryMustBeFuture"));
    }
    const expiry = Math.floor(values.expiry.valueOf() / 1000);
    if (!allowExpiredExpiry && expiry * 1000 <= Date.now()) {
        throw new Error(t("selection.admin.expiryMustBeFuture"));
    }
    const downloadAllToken = (values.downloadAllToken || "").trim();
    const archiveMarkdown =
        typeof values.archiveMarkdown === "string" && values.archiveMarkdown.trim()
            ? values.archiveMarkdown
            : "";
    if (values.downloadAllType !== "none" && !downloadAllToken) {
        throw new Error(t("selection.admin.downloadAllValueRequired"));
    }

    return {
        albumPath: resource.i,
        albumName,
        expiry,
        consent: stringifySelectionConsentClauseIds(values.consentClauses),
        downloadAllType: values.downloadAllType === "none" ? "" : values.downloadAllType,
        downloadAllToken: values.downloadAllType === "none" ? "" : downloadAllToken,
        archiveMarkdown,
    };
}
